import {
    Box,
    Container,
    Flex,
    Grid,
    GridItem,
    Heading,
    Link,
    Stack,
    Text,
    VStack,
} from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const TerminosCondicionesGuiaBroker = () => {
    return (
        <Container maxWidth="100vw" pt={{ base: 14, md: 24 }} px={{ base: 4, lg: 6 }}>
            <Header />
            <Head>
                <title>Terminos y Condiciones Guia Broker | Grupo Guía</title>
            </Head>
            <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                <GridItem colSpan={1} display={{ base: "none", md: "block" }} fontSize="16px">
                    <Stack mt="28" mb={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones"
                        >
                            Terminos y condiciones Contratación del portal
                        </Link>
                    </Stack>
                    <Stack my={4} borderLeftColor="#17669D" borderLeftWidth="3px" pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiabroker"
                        >
                            Terminos y condiciones Guía broker
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiarent"
                        >
                            Terminos y condiciones Guía Rent
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/politicanodiscriminacion"
                        >
                            Política de no discriminación
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/cartaderechosconsumidor"
                        >
                            Carta de derechos del consumidor
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiaconnect"
                        >
                            Términos y condiciones Guia Connect
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-soyinmobiliaria"
                        >
                            Terminos y condiciones Soy Inmobiliaria
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-pagocomprasonline"
                        >
                            Términos y Condiciones para la Selección de Forma de Pago en Compras en
                            Línea
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-alianzas"
                        >
                            Términos y Condiciones - Guía Alianzas
                        </Link>
                    </Stack>
                </GridItem>
                <GridItem colSpan={{ base: 4, md: 3 }}>
                    <Box mb="4" mt="24">
                        <Heading
                            as="h1"
                            fontSize={{ md: "4xl", base: "2xl" }}
                            mb="8"
                            color="accent.500"
                            fontWeight="bold"
                        >
                            Términos y Condiciones Guía Broker
                        </Heading>
                    </Box>
                    <Box lineHeight="2" mb="8">
                        <Text>
                            El presente documento describe el programa Guía Brokers, una iniciativa
                            desarrollada por Grupo Guía con el objetivo de establecer colaboraciones
                            estratégicas con asesores inmobiliarios externos que cumplan con
                            requisitos específicos y que deseen formar parte de nuestra red de
                            profesionales inmobiliarios. Este programa busca fortalecer el gremio
                            inmobiliario al facilitar una relación simbiótica entre Grupo Guía y
                            asesores externos altamente capacitados.
                        </Text>
                    </Box>
                    <Box lineHeight="2" mb="12">
                        <Text mb={6} fontWeight="bold" fontSize="2xl" color="accent.500">
                            Términos
                        </Text>
                        <Heading
                            as="h2"
                            mb="6"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            1. Términos, definiciones y términos abreviados
                        </Heading>
                        <Flex my={4}>
                            <Text>
                                Para los propósitos de este documento, se aplican en singular o
                                plural indistintamente, los términos, definiciones y términos
                                abreviados siguientes:
                            </Text>
                        </Flex>
                        <VStack spacing={6} mt={7} ml={20} align="flex-start">
                            <Text>
                                <strong>ASESORES INMOBILIARIOS EXTERNOS: </strong>
                                Agentes o agencias inmobiliarias independientes de Grupo Guia. En
                                este documento también se referirá a ellos como “asesor” o
                                “asesores”
                            </Text>
                            <Text>
                                <strong>CONCIERGE INMOBILIARIO: </strong>
                                Persona designada por Grupo Guia para la atención de los asesores
                                inmobiliarios externos que puedan o formen parte del programa Guia
                                Brokers.
                            </Text>
                            <Text>
                                <strong>DESARROLLOS: </strong>
                                Se refiere a los desarrollos inmobiliarios de los que Grupo Guia
                                tiene autorización para comercializar.
                            </Text>
                            <Text>
                                <strong>CORRETAJE: </strong>
                                Se refiere a las propiedades inmobiliarias de las que Grupo Guía
                                tiene autorización para comercializar.
                            </Text>
                            <Text>
                                <strong>GRUPO GUIA: </strong>
                                Se refiere a la persona moral GUIA EXCELENCIA INMOBILIARIA S.A. DE
                                C.V.
                            </Text>
                            <Text>
                                <strong>Criterios de Ingreso:</strong>
                            </Text>
                        </VStack>
                        <Text mt={5} mb={10}>
                            Para ser considerado como miembro del Programa Guía Brokers, se deben
                            cumplir los siguientes criterios:
                        </Text>
                        <Flex my={4}>
                            <Text mr={6}>1.1</Text>
                            <Text>
                                <strong>Invitación Formal: </strong>
                                Los asesores inmobiliarios externos deben recibir una invitación
                                oficial para formar parte del programa. Esta invitación será
                                extendida por el consierge inmobiliario de Grupo Guía, como
                                reconocimiento a la experiencia y habilidades del asesor.
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>1.2</Text>
                            <Text>
                                <strong>Documentación Legal y Regulatoria: </strong>
                                Para ser admitido, el asesor debe proporcionar documentación
                                personal o de la empresa inmobiliaria que demuestre que están
                                legalmente constituidos y cumplen con todas las regulaciones
                                vigentes para operar como corredor inmobiliario en su jurisdicción.
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>1.3</Text>
                            <Text>
                                <strong>Afiliación Gremial: </strong>
                                Los participantes deben estar afiliados a una asociación o gremio
                                inmobiliario reconocido en su área de operación. Esto garantiza el
                                compromiso del asesor con los estándares éticos y profesionales de
                                la industria.
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>1.4</Text>
                            <Text>
                                <strong>Formalización de relación comercial: </strong>
                                No existirá ni se entenderá existe relación comercial con Grupo Guia
                                sin el contrato firmado de conformidad por ambas partes, que así lo
                                demuestre.
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>1.5</Text>
                            <Text>
                                <strong>Uso Adecuado de Información: </strong>
                                Para asegurar la confidencialidad y protección de la información, el
                                asesor deberá acordar y cumplir con las pautas definidas en los
                                documentos de Grupo Guia, mencionando en forma enunciativa más no
                                limitativa: convenio relacionadas con el uso y manejo de la
                                información proporcionada por Grupo Guía, políticas, manuales,
                                términos y condiciones, aviso de privacidad.
                            </Text>
                        </Flex>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            2. Limitación de Asesores por Ciudad:
                        </Heading>
                        <Text mb={8}>
                            A discreción de Grupo Guia se establecerá un límite de asesores por
                            ciudad con el fin de garantizar un enfoque colaborativo y un servicio de
                            calidad. En este momento se informa el límite de 80 asesores
                            inmobiliarios, mismo que podrá ser modificado en aumento o disminución
                            sin previo aviso, de conformidad con los estudios que Grupo Guia realice
                            para la correcta determinación del número.
                        </Text>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            3. Requisitos de Permanencia:
                        </Heading>
                        <Text mb={8}>
                            Para mantener su membresía en el programa, los asesores deben cumplir
                            con los siguientes requisitos:
                        </Text>
                        <Flex my={4}>
                            <Text mr={6}>3.1</Text>
                            <Text>
                                <strong>Participación Activa: </strong>
                                Se espera que los asesores participen activamente en los eventos,
                                presentaciones y capacitaciones organizados por Grupo Guía para
                                promover el crecimiento profesional y la actualización constante.
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>3.2</Text>
                            <Text>
                                <strong>Ética y Honestidad: </strong>
                                Los participantes deben adherirse al reglamento de ética y
                                honestidad establecido en el programa, garantizando prácticas
                                profesionales transparentes y confiables.
                            </Text>
                        </Flex>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            4. Registro de Clientes:
                        </Heading>
                        <Text mb={8}>
                            {`El registro de clientes se realiza exclusivamente a través de la sección
                                "SOY INMOBILIARIA" en el sitio web de Grupo Guía: `}
                            <u>www.grupoguia.mx.</u>
                        </Text>
                        <Flex my={4}>
                            <Text mr={6}>4.1</Text>
                            <Text>
                                {`Queda estrictamente prohibido que los asesores de Grupo Guía
                                    contacten de manera directa al cliente de la inmobiliaria. Todo
                                    seguimiento al cliente de la inmobiliaria debe ser a través del
                                    ASESOR INMOBILIARIO EXTERNO, de igual manera el asesor de Grupo Guía
                                    deberá registrar el seguimiento que le indique la inmobiliaria
                                    dentro del CRM controlado por Grupo Guía, ya que estos registros
                                    también se sujetan a la política del CRM: "La vigencia de un negocio
                                    es de 30 días a partir de la última interacción. La interacción se
                                    considera a partir de la acción, relación y comunicación entre 2 o
                                    más personas con la intención de concretar un negocio registrado`}
                            </Text>
                        </Flex>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            5. Beneficios del Programa:
                        </Heading>
                        <Text mb={8}>
                            Los miembros del Programa Guía Brokers acceden a una serie de beneficios
                            exclusivos que enriquecen su carrera y les brindan ventajas
                            competitivas:
                        </Text>
                        <Flex my={4}>
                            <Text mr={6}>5.1</Text>
                            <Text>
                                <strong>Acceso Preferente: </strong>
                                Los miembros tienen acceso preferente a lanzamientos y preventas de
                                desarrollos en exclusiva por Grupo Guía, permitiéndoles ofrecer
                                oportunidades únicas a su cartera de clientes
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>5.2</Text>
                            <Text>
                                <strong>Información en Tiempo Real: </strong>
                                Los asesores obtienen acceso a información actualizada sobre el
                                inventario disponible, lo que facilita su toma de decisiones y su
                                capacidad para proporcionar opciones atractivas a sus clientes.
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>5.3</Text>
                            <Text>
                                <strong>Registro de Clientes en Línea: </strong>
                                La posibilidad de registrar clientes en línea, las 24 horas del día,
                                7 días a la semana, agiliza y simplifica el proceso de trabajo. Este
                                registro será a través de la plataforma seleccionada por Grupo Guia.
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>5.4</Text>
                            <Text>
                                <strong>Capacitaciones Personalizadas: </strong>
                                Se podrán ofrecer capacitaciones tanto presenciales como virtuales
                                para garantizar un desarrollo profesional continuo. Esta
                                capacitación se encuentra dirigida a obtener conocimientos generales
                                para el sector inmobiliario y en ninguna circunstancia se entenderá
                                como capacitación para cumplir instrucciones de Grupo Guia, ya que
                                entre las partes no existe relación laboral.
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>5.5</Text>
                            <Text>
                                <strong>Atención Personalizada: </strong>
                                El equipo de consierge inmobiliario de Grupo Guía brinda atención y
                                seguimiento personalizado para satisfacer las necesidades
                                individuales de los asesores y sus clientes.
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>5.6</Text>
                            <Text>
                                <strong>
                                    Acceso a alianza de capacitaciones y certificaciones con
                                    descuento:{" "}
                                </strong>
                                Los miembros pueden acceder a capacitaciones y certificaciones
                                presenciales o en línea a través de MENTOR con un 20% de descuento.
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>5.7</Text>
                            <Text>
                                <strong>Colaboración Profesional: </strong>
                                Los miembros podrán colaborar con otros asesores y profesionales
                                inmobiliarios, fomentando el intercambio de ideas, experiencias e
                                inventario, así como requerimientos.
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>5.8</Text>
                            <Text>
                                <strong>Seguimiento a Posventa: </strong>
                                El equipo de concierge inmobiliario se encarga de dar seguimiento a
                                la posventa de las operaciones, buscando asegurar la satisfacción
                                completa de los clientes y una experiencia integral.
                            </Text>
                        </Flex>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            6. No relación laboral:
                        </Heading>
                        <Text mb={8}>
                            El programa GUIA BROKERS es una relación mercantil. Las partes no
                            guardan relación laboral y son responsables en forma directa respecto a
                            las obligaciones que como patrón pudiera tener cada uno con terceros en
                            forma independiente. Las partes deberán dejarse a salvo y en paz
                            respecto de personas que guarden relación laboral con la parte que
                            corresponda.
                            <br />
                            <br />
                            Grupo Guia no dará instrucciones respecto a la forma en que deba
                            trabajar el asesor, limitándose a establecer los términos y condiciones
                            comerciales bajo los que pueden ser comercializas las propiedades a las
                            que da acceso el programa Guia Brokers.
                        </Text>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            7. Obligaciones legales y fiscales:
                        </Heading>
                        <Text mb={8}>
                            El programa Guia Brokers no exime a las partes del cumplimiento directo
                            que por disposición legal deban realizar. Cada una de las partes son
                            responsables de observar y cumplir con lo dispuesto por la legislación
                            que resulte aplicable.
                            <br />
                            <br />
                            En materia de prevención de lavado de dinero, será responsabilidad de
                            las partes atender a la legislación, su reglamento y de resultarle
                            aplicable dar el aviso correspondiente a la autoridad, en tiempo y
                            forma. Las partes coadyuvarán en el cumplimiento de sus obligaciones
                            respecto a la entrega de información y/o documentación que fuere
                            requerida.
                            <br />
                            <br />
                            En materia fiscal, cada una de las partes es responsable de la
                            generación de facturas y pago de impuestos que les corresponda. No
                            existe obligación solidaria.
                            <br />
                            <br />
                            Para el pago de cualquier cantidad que por relación contractual resulte
                            acreedor el asesor, deberá expedir con anticipación una factura que
                            reúna todos los requisitos legales y fiscales aplicables.
                        </Text>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            8. Inalterabilidad:
                        </Heading>
                        <Text mb={8}>
                            Este documento es un anexo y no sustituye o modifica los acuerdos
                            contractuales que existan entre las partes.
                        </Text>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            9. Publicidad:
                        </Heading>
                        <Text mb={8}>
                            El programa GUIA BROKERS no se entenderá en ningún momento como una
                            licencia de uso de las marcas con las que “Guia” comercializa o bien las
                            de cualquier desarrollador a las que pertenezca cualquiera de las
                            propiedades.
                            <br />
                            <br />
                            El asesor o asesores que formen parte de este programa podrán generar
                            publicidad que busque una segmentación abierta con las propiedades a las
                            que este programa les da acceso, con la limitante de no poder mencionar
                            el nombre comercial del desarrollo, las marcas del desarrollador,
                            constructor y/o de “Guia”.
                            <br />
                            <br />
                            Todas las fotografías, videos y material publicitario con el que “Guia”
                            promueve las propiedades son derechos reservados y el programa “Guia
                            Brokers” no otorga una licencia de uso por lo que no se deberá utilizar
                            en forma total o parcial, bajo ningún medio, por parte de los asesores.
                        </Text>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            Conclusión:
                        </Heading>
                        <Text mb={20}>
                            El Programa Guía Brokers es una iniciativa diseñada para enriquecer el
                            ecosistema inmobiliario a través de alianzas estratégicas entre Grupo
                            Guía y asesores inmobiliarios externos. Al reunir a profesionales
                            calificados y comprometidos, el programa busca elevar los estándares de
                            la industria y fomentar relaciones mutuamente beneficiosas.
                        </Text>
                    </Box>
                </GridItem>
            </Grid>
            <Footer visible={false} />
        </Container>
    );
};

export default TerminosCondicionesGuiaBroker;
